/* =============================================================
   SS — Formulaire de contact
   - Présélection du sujet via paramètre d'URL (?sujet=…)
   - Focus sur le message de succès / d'erreur après envoi
   - Anti double-soumission
   ============================================================= */

if (!customElements.get('ss-contact-form')) {
  customElements.define(
    'ss-contact-form',
    class SSContactForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');

        this.presetSubject();
        this.focusMessage();

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }
      }

      /* Ouvre le formulaire sur un sujet donné : /pages/contact?sujet=Service client */
      presetSubject() {
        const select = this.querySelector('[data-ss-cf-subject]');
        if (!select) return;

        const param = this.dataset.subjectParam || 'sujet';
        let wanted;

        try {
          wanted = new URLSearchParams(window.location.search).get(param);
        } catch (error) {
          return;
        }

        if (!wanted) return;

        const normalize = (value) =>
          value
            .toString()
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

        const target = normalize(wanted);
        const match = Array.from(select.options).find(
          (option) => normalize(option.value) === target || normalize(option.text) === target
        );

        if (match) select.value = match.value;
      }

      /* Après rechargement, amène le visiteur sur le retour du formulaire */
      focusMessage() {
        const message = this.querySelector('[data-ss-cf-message]');
        if (!message) return;

        requestAnimationFrame(() => {
          message.focus({ preventScroll: true });
          message.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      onSubmit() {
        const submit = this.querySelector('.ss-cf__submit');
        if (!submit || !this.form.checkValidity()) return;

        submit.setAttribute('disabled', '');
        // Le formulaire recharge la page : garde-fou si la requête échoue.
        window.setTimeout(() => submit.removeAttribute('disabled'), 8000);
      }
    }
  );
}